export default __webpack_public_path__ + "static/media/07_bag 2.fac34355.gif";